import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const usePagosStore = defineStore('pagos', {
  state: () => ({
    pagos: [],
    loading: false,
    error: null,
    search: [],
    search_query: '',
    perPage: 20,
    page: 1,
    currentPage: 1,
    totalPagos: 0,
    totalPages: 1
  }),
  actions: {
    async fetchPagos({
      page,
      rows,
      search,
      search_query,
      perPage,
      fecha = null
    } = {}) {
      this.loading = true
      try {
        const response = await api.get('/pagos', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            page: page || this.page,
            rows: rows || this.rows,
            search: search || this.search,
            search_query: search_query || this.search_query,
            per_page: perPage || this.perPage,
            fecha: fecha || null
          }
        })
        this.pagos = response.data.items
        this.totalPagos = response.data.total
        this.totalPages = response.data.pages
        this.perPage = response.data.per_page
        this.page = response.data.page
        return this.pagos
      } catch (error) {
        this.error = error
        console.error('Error al obtener pagos:', error)
        throw error
      } finally {
        this.loading = false
      }
    },
    async createPago(pago) {
      try {
        const response = await api.post('/pagos', pago, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.pagos.push(response.data)
        return response.data
      } catch (error) {
        this.error = error
        console.error('Error al crear pago:', error)
        throw error
      }
    },
    async updatePago(pago) {
      try {
        const response = await api.put(`/pagos/${pago.id}`, pago, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        const index = this.pagos.findIndex((p) => p.id === pago.id)
        if (index !== -1) {
          this.pagos[index] = response.data
        }
        return response.data
      } catch (error) {
        this.error = error
        console.error('Error al actualizar pago:', error)
        throw error
      }
    },
    async deletePago(id) {
      try {
        await api.delete(`/pagos/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.pagos = this.pagos.filter((p) => p.id !== id)
      } catch (error) {
        this.error = error
        console.error('Error al eliminar pago:', error)
        throw error
      }
    },
    setSearch(search) {
      this.search = search
    },
    setRows(rows) {
      this.rows = rows
    },
    setPage(page) {
      this.page = page
    },
    async getPago(id) {
      try {
        const response = await api.get(`/pagos/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error al obtener pago:', error)
        throw error
      }
    }
  }
})
